document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('[data-sizeguide-trigger]');
  if (triggers.length === 0) return;

  class SizeGuideApp {
    constructor() {
      this.flowDataMap = {}; // 取得済みのデータと在庫をキャッシュ
      this.currentData = null; // 現在開いているモーダルのデータ
      this.historyStack = []; // 戻るボタン用の履歴
      this.elements = {}; // DOM要素の参照を保持

      this.initDOM();
      this.bindEvents();
    }

    // 1. モーダルの枠組みを1度だけ生成
    initDOM() {
      if (document.querySelector('.sizeguide_popup')) return;

      const displayArea = document.createElement('div');
      displayArea.className = 'sizeguide_popup';
      displayArea.innerHTML = `
        <div class="sizeguide_popup_overlay" data-sizeguide-overlay></div>
        <div class="sizeguide_popup_container">
          <div class="sizeguide_popup_close" data-sizeguide-close></div>
          <div class="sizeguide_popup_head">
            <p class="sizeguide_popup_title">Find your fit</p>
            <p class="sizeguide_popup_detail">Answer a few questions and we’ll show your size</p>
          </div>
          <div class="sizeguide_popup_wrap">
            <p class="sizeguide_popup_coltitle"></p>
            <div class="sizeguide_popup_line"><span></span></div>
            <div class="sizeguide_popup_content" data-sizeguide-content></div>
          </div>
        </div>
      `;
      document.body.appendChild(displayArea);

      this.elements = {
        area: displayArea,
        content: displayArea.querySelector('[data-sizeguide-content]'),
        progress: displayArea.querySelector('.sizeguide_popup_line span'),
        title: displayArea.querySelector('.sizeguide_popup_coltitle'),
        wrap: displayArea.querySelector('.sizeguide_popup_wrap'),
        container: displayArea.querySelector('.sizeguide_popup_container')
      };

      displayArea.querySelector('[data-sizeguide-close]').addEventListener('click', () => this.close());
      displayArea.querySelector('[data-sizeguide-overlay]').addEventListener('click', () => this.close());
    }

    // 2. ページ内の全トリガーボタンにイベントを登録
    bindEvents() {
      document.querySelectorAll('[data-sizeguide-trigger]').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          const handle = btn.dataset.sizeguideTrigger;
          await this.open(handle);
        });
      });
    }

    // 3. モーダルを開く処理（毎回状態をリセットする）
    async open(handle) {
      // 履歴とUIを強制リセット（混線防止）
      this.historyStack = [];
      this.elements.content.innerHTML = '<p style="text-align:center; padding: 20px;">Loading data...</p>';
      this.elements.progress.style.width = '0%';
      this.elements.area.classList.add('is-active');

      // データがキャッシュされていなければAPIから取得
      if (!this.flowDataMap[handle]) {
        const rawData = this.getModalDataByHandle(handle);
        if (!rawData) {
          this.elements.content.innerHTML = '<p>Error: Data not found.</p>';
          return;
        }

        // 在庫APIを叩く（ボタンを押した初回のみ）
        const inventoryResult = await this.fetchInventory(handle, rawData);
        rawData.stockInfo = inventoryResult.stockMap;
        rawData.availableSizes = inventoryResult.availableSizes;
        this.flowDataMap[handle] = rawData;
      }

      this.currentData = this.flowDataMap[handle];

      // UIの基本情報をセット
      this.elements.title.textContent = this.currentData.title;
      this.elements.wrap.className = `sizeguide_popup_wrap ${this.currentData.handle}`;

      // 最初のステップを描画
      if (this.currentData.firstStep) {
        this.showFirstStep();
      } else {
        this.showResult("General Guide", this.currentData.results["fixed_size"], "fixed_size", true);
      }
    }

    close() {
      this.elements.area.classList.remove('is-active');
      this.currentData = null;
      this.historyStack = [];
    }

    // --- 以降は描画ロジック ---
    showFirstStep() {
      this.historyStack.push(() => this.showFirstStep());
      this.updateProgress('first');

      const items = this.currentData.firstStep.options.map(item => ({
        label: item.label,
        action: () => this.showSecondStep(item.id, item.label)
      }));
      this.renderView(items, null, this.currentData.firstStep.question, ['first']);
    }

    showSecondStep(firstStepId, firstStepLabel) {
      this.historyStack.push(() => this.showSecondStep(firstStepId, firstStepLabel));
      this.updateProgress('second');

      const stepData = this.currentData.secondStep;
      const question = typeof stepData.question === 'object' ? stepData.question[firstStepId] : stepData.question;
      const cls = stepData.column === "double" ? ['second', 'double_col'] : ['second'];

      const items = (stepData[firstStepId] || []).map(item => ({
        label: item.label || item.text,
        resultId: item.resultId,
        action: () => {
          if (item.thirdStepId) this.showThirdStep(item.thirdStepId, item.id, firstStepId, firstStepLabel);
          else this.showResult(item.label, this.currentData.results[item.resultId], item.resultId);
        }
      }));

      this.renderView(items, () => this.goBack(), question, cls);
    }

    showThirdStep(groupId, parentLabel, firstStepId, firstStepLabel) {
      this.historyStack.push(() => this.showThirdStep(groupId, parentLabel, firstStepId, firstStepLabel));
      this.updateProgress('third');

      const stepData = this.currentData.thirdStep;
      const selectedGroup = stepData[firstStepId] ? stepData[firstStepId][groupId] : stepData[groupId];
      const question = typeof stepData.question === 'object' ? stepData.question[firstStepId] : stepData.question;

      const items = selectedGroup.map(item => ({
        label: item.label,
        resultId: item.resultId,
        action: () => this.showResult(item.label, this.currentData.results[item.resultId], item.resultId)
      }));

      this.renderView(items, () => this.goBack(), question, ['third']);
    }

    showResult(title, msg, resultId, resultOnlyFlg = null) {
      this.historyStack.push(() => this.showResult(title, msg, resultId, resultOnlyFlg));
      this.updateProgress('result');
      this.elements.content.innerHTML = "";

      const oldBtn = this.elements.wrap.querySelector('.back-btn');
      if (oldBtn) oldBtn.remove();

      // --- 【修正箇所】テーブルのみ（resultOnlyFlg）じゃない時だけ戻るボタンを追加 ---
      if (!resultOnlyFlg) {
        const backBtn = document.createElement('div');
        backBtn.className = "back-btn";
        backBtn.onclick = () => this.goBack();
        this.elements.wrap.appendChild(backBtn);
      }

      const container = document.createElement('div');
      container.className = "fade-in result-container";

      const currentData = this.flowDataMap[this.currentData.handle] || this.currentData;
      const isOutOfStock = resultId && currentData.stockInfo && currentData.stockInfo[resultId] === false;

      if(resultOnlyFlg) {
        if (this.currentData.isGridModal) {
          container.innerHTML = `<div class="result result-jacket">${this.currentData.generateGrid.call(this, 'us')}</div>`;
          // Gridイベントの初期化等はここに記述...
        }
      } else {
        let finalHref = "";
        const handle = this.currentData.handle;
        const buttonLabel = this.currentData.title.replace(/Men's|Women's/gi, "").trim().toLowerCase();

        if (handle.includes('shirt')) {
          const shirtMatch = msg.match(/^(.*?)(\d{2})$/);
          if (shirtMatch) {
            finalHref = `/collections/${handle}?filter.v.option.size=${shirtMatch[1]}&filter.v.m.custom.y_sleeve_length=${shirtMatch[2]}&filter.v.availability=1`;
          } else {
            finalHref = `/collections/${handle}?filter.v.option.size=${msg}&filter.v.availability=1`;
          }
        } else {
          const filter = msg.replace(/([A-Z]+)(\d+)/g, '$1+$2');
          finalHref = `/collections/${handle}?filter.v.option.size=${filter}&filter.v.availability=1`;
        }

        let linkTag = isOutOfStock
          ? `<a href="javascript:void(0);" class="button out-stock"><span>Out of stock</span></a>`
          : `<a href="${finalHref}" class="button"><span>Shop your size ${buttonLabel}</span></a>`;

        container.innerHTML = `
          <div class="result">
            <p class="result_size">Your size is<span class="wg-custom-notranslate">${msg}</span></p>
            <p class="result_detail">Fits may vary by style or personal preference...</p>
            <div class="result_btn">${linkTag}</div>
          </div>
        `;
      }
      this.elements.content.appendChild(container);
    }

    renderView(items, backAction, questionText, cls = []) {
      const oldBtn = this.elements.wrap.querySelector('.back-btn');
      if (oldBtn) oldBtn.remove();
      if (backAction) {
        const backBtn = document.createElement('div');
        backBtn.className = "back-btn";
        backBtn.onclick = backAction;
        this.elements.wrap.appendChild(backBtn);
      }

      this.elements.content.innerHTML = "";
      const container = document.createElement('div');
      container.className = "fade-in " + cls.join(' ');

      if (questionText) {
        const qElement = document.createElement('div');
        qElement.className = "sizeguide_popup_question";
        qElement.innerHTML = questionText;
        container.appendChild(qElement);
      }

      const itemsDiv = document.createElement('div');
      itemsDiv.className = "clickable-items";

      items.forEach(opt => {
        const div = document.createElement('div');
        div.className = "clickable-item";

        const isOutOfStock = opt.resultId && this.currentData.stockInfo && this.currentData.stockInfo[opt.resultId] === false;

        if (isOutOfStock) {
          div.classList.add('out-stock');
          div.innerHTML = opt.label + '<span class="stock-label">Out of Stock</span>';
          div.onclick = (e) => { e.stopPropagation(); alert("This size is currently out of stock."); };
        } else {
          div.innerHTML = opt.label;
          div.onclick = opt.action;
        }
        itemsDiv.appendChild(div);
      });

      container.appendChild(itemsDiv);
      this.elements.content.appendChild(container);
    }

    goBack() {
      if (this.historyStack.length > 1) {
        this.historyStack.pop();
        const prev = this.historyStack.pop();
        prev();
      } else {
        this.close();
      }
    }

    updateProgress(step) {
      if (!this.elements.progress) return;
      let totalQuestions = 0;
      if (this.currentData.firstStep) totalQuestions++;
      if (this.currentData.secondStep) totalQuestions++;
      if (this.currentData.thirdStep) totalQuestions++;
      const totalSteps = totalQuestions + 1;

      let currentIdx = 0;
      switch (this.currentStepName) {
        case 'first': currentIdx = 1; break;
        case 'second': currentIdx = 2; break;
        case 'third': currentIdx = 3; break;
        case 'result': currentIdx = totalSteps; break;
      }

      const percentage = (currentIdx / totalSteps) * 100;
      this.elements.progress.style.width = `${percentage}%`;
    }

    async fetchInventory(handle, rawData) {
      // 在庫取得API
      try {
        // 1. URLを確実に生成
        const url = `/collections/${handle}/products.json?limit=250`;
        const response = await fetch(url);
        // レスポンスが正常かチェック
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const resData = await response.json();
        const availableSizes = new Set();

        // --- 修正ポイント：データの入り方を柔軟に判定する ---
        // resData.products があればそれを使用、なければ resData 自体が配列か確認
        const productsArray = resData.products ? resData.products : (Array.isArray(resData) ? resData : null);

        if (productsArray) {
          productsArray.forEach(product => {
            product.variants.forEach(variant => {
              if (variant.available) {
                if (handle.includes('shirt')) {
                  // --- シャツ専用：Option2とOption3を結合して保存 ---
                  // 例: option2="M", option3="Regular" -> "M Regular"
                  const combined = `${variant.option2} ${variant.option3}`.trim();
                  availableSizes.add(combined);
                } else {
                  // 通常商品：すべてのオプションを個別に保存
                  [variant.option1, variant.option2, variant.option3].forEach(opt => {
                    if (opt) {
                      availableSizes.add(opt.toString().trim());
                      const num = parseFloat(opt);
                      if (!isNaN(num)) {
                        availableSizes.add(num.toString());
                        availableSizes.add(num.toFixed(1));
                      }
                    }
                  });
                }
              }
            });
          });
        }

        // --- マッピングテーブルの定義 ---
        const shirtMap = {
          "yes_S78": "S Short",
          "no_S78": "S Short",
          "yes_S82": "S Regular",
          "no_S82": "S Regular",
          "yes_M80": "M Short",
          "no_M80": "M Short",
          "yes_M84": "M Regular",
          "no_M84": "M Regular",
          "yes_M88": "M Long",
          "no_M88": "M Long",
          "yes_L82": "L Short",
          "no_L82": "L Short",
          "yes_L86": "L Regular",
          "no_L86": "L Regular",
          "yes_L90": "L Long",
          "no_L90": "L Long",
          "yes_LL82": "LL Short",
          "no_LL82": "LL Short",
          "yes_LL86": "LL Regular",
          "no_LL86": "LL Regular",
          "yes_3L87": "3L Regular",
          "no_3L87": "3L Regular"
        };

        // resultIdごとのフラグマップを作成
        const stockMap = {};
        const modalDataTemp = this.getModalDataByHandle(handle);
        if (modalDataTemp && modalDataTemp.results) {
          Object.keys(modalDataTemp.results).forEach(key => {
            const sizeVal = modalDataTemp.results[key].toString().trim(); // 例: "M84"
            let hasStock = false;

            if (handle.includes('shirt')) {
              const target = shirtMap[key] || shirtMap[sizeVal]; // key(yes_4L88)か値(4L88)で引く
              hasStock = availableSizes.has(target);
            } else {
              // 通常判定
              const sizeWithSpace = sizeVal.replace(/([A-Z]+)(\d+)/g, '$1 $2');
              const num = parseFloat(sizeVal);
              hasStock = availableSizes.has(sizeVal) || availableSizes.has(sizeWithSpace) || (!isNaN(num) && (availableSizes.has(num.toString()) || availableSizes.has(num.toFixed(1))));
            }
            stockMap[key] = hasStock;
          });
        }
        return { stockMap, availableSizes };
      } catch (e) {
        console.error(`[Inventory] Fetch error for ${handle}:`, e);
        return { stockMap: {}, availableSizes: new Set() };
      }
    }

    getModalDataByHandle(handle) {
      const menBusinessSuitsModal = (handle) => {
        const slimImg = `<div class="sizeguide_popup_img"><img src="https://cdn.shopify.com/s/files/1/0790/7501/7011/files/pg_sizeguide_popup-slim.svg" alt="Slim" width="110" height="110" loading="lazy"></div>`
        const standardImg = `<div class="sizeguide_popup_img"><img src="https://cdn.shopify.com/s/files/1/0790/7501/7011/files/pg_sizeguide_popup-standard.svg" alt="Standard/Average" width="110" height="110" loading="lazy"></div>`
        const broadImg = `<div class="sizeguide_popup_img"><img src="https://cdn.shopify.com/s/files/1/0790/7501/7011/files/pg_sizeguide_popup-broad.svg" alt="Broad" width="110" height="110" loading="lazy"></div>`
        const fullImg = `<div class="sizeguide_popup_img"><img src="https://cdn.shopify.com/s/files/1/0790/7501/7011/files/pg_sizeguide_popup-full.svg" alt="Full" width="110" height="110" loading="lazy"></div>`

        return {
          title: "Men's Business Suits",
          handle: handle,
          firstStep: {
            question: `<p>How tall are you?</p>`,
            options: [
              { id: "h160", label: `<b class="wg-custom-notranslate">160 - 165cm <span>5'2" ～ 5'4"</span></b>` },
              { id: "h165", label: `<b class="wg-custom-notranslate">165 - 170cm <span>5'4" ～ 5'6"</span></b>` },
              { id: "h170", label: `<b class="wg-custom-notranslate">170 - 175cm <span>5'6" ～ 5'7"</span></b>` },
              { id: "h175", label: `<b class="wg-custom-notranslate">175 - 180cm <span>5'7" ～ 5'9"</span></b>` },
              { id: "h180", label: `<b class="wg-custom-notranslate">180 - 185cm <span>5'9" ～ 6'1"</span></b>` }
            ]
          },
          secondStep: {
            question: `<p>How do you describe your build?</p>`,
            column: "double",
            "h160": [
              {
                id: "secondA",
                label: `${slimImg}<p><b>Slim</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>71～74～77cm<br>28～29～30inch</span></p></div>`,
                resultId: "result_Y4"
              },
              {
                id: "secondB",
                label: `${standardImg}<p><b>Standard/Average</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>75～78～81cm<br>30～31～32inch</span></p></div>`,
                resultId: "result_A4"
              },
              {
                id: "secondC",
                label: `${broadImg}<p><b>Broad</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>81～84～87cm<br>32～33～34inch</span></p></div>`,
                resultId: "result_AB4"
              },
              {
                id: "secondD",
                label: `${fullImg}<p><b>Full</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>89～92～95cm<br>35～36～37inch</span></p></div>`,
                resultId: "result_BB4"
              },
            ],
            "h165": [
              {
                id: "secondA",
                label: `${slimImg}<p><b>Slim</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>73～76～79cm<br>29～30～31inch</span></p></div>`,
                resultId: "result_Y5"
              },
              {
                id: "secondB",
                label: `${standardImg}<p><b>Standard/Average</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>77～80～83cm<br>30～31～33inch</span></p></div>`,
                resultId: "result_A5"
              },
              {
                id: "secondC",
                label: `${broadImg}<p><b>Broad</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>83～86～89cm<br>33～34～35inch</span></p></div>`,
                resultId: "result_AB5"
              },
              {
                id: "secondD",
                label: `${fullImg}<p><b>Full</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>91～94～97cm<br>36～37～38inch</span></p></div>`,
                resultId: "result_BB5"
              },
            ],
            "h170": [
              {
                id: "secondA",
                label: `${slimImg}<p><b>Slim</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>75～78～81cm<br>30～31～32inch</span></p></div>`,
                resultId: "result_Y6"
              },
              {
                id: "secondB",
                label: `${standardImg}<p><b>Standard/Average</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>79～82～85cm<br>31～32～33inch</span></p></div>`,
                resultId: "result_A6"
              },
              {
                id: "secondC",
                label: `${broadImg}<p><b>Broad</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>85～88～91cm<br>33～35～36inch</span></p></div>`,
                resultId: "result_AB6"
              },
              {
                id: "secondD",
                label: `${fullImg}<p><b>Full</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>93～96～99cm<br>37～38～39inch</span></p></div>`,
                resultId: "result_BB6"
              },
            ],
            "h175": [
              {
                id: "secondA",
                label: `${slimImg}<p><b>Slim</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>77～80～83cm<br>30～31～33inch</span></p></div>`,
                resultId: "result_Y7"
              },
              {
                id: "secondB",
                label: `${standardImg}<p><b>Standard/Average</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>81～84～87cm<br>32～33～34inch</span></p></div>`,
                resultId: "result_A7"
              },
              {
                id: "secondC",
                label: `${broadImg}<p><b>Broad</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>87～90～93cm<br>34～35～37inch</span></p></div>`,
                resultId: "result_AB7"
              },
              {
                id: "secondD",
                label: `${fullImg}<p><b>Full</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>95～98～101cm<br>37～39～40inch</span></p></div>`,
                resultId: "result_BB7"
              },
            ],
            "h180": [
              {
                id: "secondA",
                label: `${slimImg}<p><b>Slim</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>79～82～85cm<br>31～32～33inch</span></p></div>`,
                resultId: "result_Y8"
              },
              {
                id: "secondB",
                label: `${standardImg}<p><b>Standard/Average</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>83～86～89cm<br>33～34～35inch</span></p></div>`,
                resultId: "result_A8"
              },
              {
                id: "secondC",
                label: `${broadImg}<p><b>Broad</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>89～92～95cm<br>35～36～37inch</span></p></div>`,
                resultId: "result_AB8"
              },
              {
                id: "secondD",
                label: `${fullImg}<p><b>Full</b></p><div><p><b>waist<br>size</b></p><p class="wg-custom-notranslate"><span>97～100～103cm<br>38～39～41inch</span></p></div>`,
                resultId: "result_BB8"
              },
            ]
          },
          results: {
            "result_Y4": "Y4",
            "result_A4": "A4",
            "result_AB4": "AB4",
            "result_BB4": "BB4",
            "result_Y5": "Y5",
            "result_A5": "A5",
            "result_AB5": "AB5",
            "result_BB5": "BB5",
            "result_Y6": "Y6",
            "result_A6": "A6",
            "result_AB6": "AB6",
            "result_BB6": "BB6",
            "result_Y7": "Y7",
            "result_A7": "A7",
            "result_AB7": "AB7",
            "result_BB7": "BB7",
            "result_Y8": "Y8",
            "result_A8": "A8",
            "result_AB8": "AB8",
            "result_BB8": "BB8"
          }
        };
      }
      const menBusinessShirtModal = (handle) => {
        const collarImg = `<div class="sizeguide_popup_img"><img src="https://cdn.shopify.com/s/files/1/0790/7501/7011/files/pg_sizeguide_popup-collar.svg" alt="Collor" width="140" height="140" loading="lazy"></div>`

        return {
          title: "Men's Dress Shirt",
          handle: handle,
          firstStep: {
            question: `<p>Do you know your collar size (cm/inch)?</p>${collarImg}`,
            options: [
              { id: "yes", label: `<b>Yes</b>` },
              { id: "no", label: `<b>No</b>` }
            ]
          },
          secondStep: {
            question: {
              "yes": `<p>What is your collar size?</p>`,
              "no": `<p>How tall are you?</p>`
            },
            "yes": [
              {
                id: "secondA",
                label: `<p class="wg-custom-notranslate"><b>S</b><span>37cm (14.5inch)</span></p>`,
                thirdStepId: "size_S"
              },
              {
                id: "secondB",
                label: `<p class="wg-custom-notranslate"><b>M</b><span>39cm (15.4inch)</span></p>`,
                thirdStepId: "size_M"
              },
              {
                id: "secondC",
                label: `<p class="wg-custom-notranslate"><b>L</b><span>41cm (16.2inch)</span></p>`,
                thirdStepId: "size_L"
              },
              {
                id: "secondD",
                label: `<p class="wg-custom-notranslate"><b>LL</b><span>43cm (17inch)</span></p>`,
                thirdStepId: "size_LL"
              },
              {
                id: "secondF",
                label: `<p class="wg-custom-notranslate"><b>3L</b><span>45cm (17.8inch)</span></p>`,
                thirdStepId: "size_3L"
              }
            ],
            "no": [
              {
                id: "secondA",
                label: `<p class="wg-custom-notranslate"><b>165-170cm</b><span>5'4"～5'6"</span></p>`,
                thirdStepId: "size_165"
              },
              {
                id: "secondB",
                label: `<p class="wg-custom-notranslate"><b>170-175cm</b><span>5'6"～5'7"</span></p>`,
                thirdStepId: "size_170"
              },
              {
                id: "secondC",
                label: `<p class="wg-custom-notranslate"><b>175-180cm</b><span>5'7"～5'9"</span></p>`,
                thirdStepId: "size_175"
              },
              {
                id: "secondD",
                label: `<p class="wg-custom-notranslate"><b>180-185cm</b><span>5'9"～6'1"</span></p>`,
                thirdStepId: "size_180"
              }
            ]
          },
          thirdStep: {
            question: {
              "yes": `<p>What is your sleeve length?</p>`,
              "no": `<p>What is your weight?</p>`
            },
            "yes": {
              "size_S": [
                { label: "<b class='wg-custom-notranslate'>Short</b><span class='wg-custom-notranslate'>78cm (30.8inch)</span>", resultId: "yes_S78" },
                { label: "<b class='wg-custom-notranslate'>Regular</b><span class='wg-custom-notranslate'>82cm (32.3inch)</span>", resultId: "yes_S82" }
              ],
              "size_M": [
                { label: "<b class='wg-custom-notranslate'>Short</b><span class='wg-custom-notranslate'>80cm (31.5inch)</span>", resultId: "yes_M80" },
                { label: "<b class='wg-custom-notranslate'>Regular</b><span class='wg-custom-notranslate'>84cm (33.1inch)</span>", resultId: "yes_M84" },
                { label: "<b class='wg-custom-notranslate'>Long</b><span class='wg-custom-notranslate'>88cm (34.7inch)</span>", resultId: "yes_M88" }
              ],
              "size_L": [
                { label: "<b class='wg-custom-notranslate'>Short</b><span class='wg-custom-notranslate'>82cm (32.3inch)</span>", resultId: "yes_L82" },
                { label: "<b class='wg-custom-notranslate'>Regular</b><span class='wg-custom-notranslate'>86cm (33.9inch)</span>", resultId: "yes_L86" },
                { label: "<b class='wg-custom-notranslate'>Long</b><span class='wg-custom-notranslate'>90cm (35.5inch)</span>", resultId: "yes_L90" }
              ],
              "size_LL": [
                { label: "<b class='wg-custom-notranslate'>Short</b><span class='wg-custom-notranslate'>82cm (32.3inch)</span>", resultId: "yes_LL82" },
                { label: "<b class='wg-custom-notranslate'>Regular</b><span class='wg-custom-notranslate'>86cm (33.9inch)</span>", resultId: "yes_LL86" }
              ],
              "size_3L": [
                { label: "<b class='wg-custom-notranslate'>Regular</b><span class='wg-custom-notranslate'>87cm (34.3inch)</span>", resultId: "yes_3L87" }
              ]
            },
            "no": {
              "size_165": [
                { label: "<b class='wg-custom-notranslate'>60-65 kg <span>(132-143 lb)</span></b>", resultId: "no_S82" },
                { label: "<b class='wg-custom-notranslate'>65-70 kg <span>(143-154 lb)</span></b>", resultId: "no_M80" },
                { label: "<b class='wg-custom-notranslate'>70-75 kg <span>(154-165 lb)</span></b>", resultId: "no_L82" },
                { label: "<b class='wg-custom-notranslate'>75-80 kg <span>(165-176 lb)</span></b>", resultId: "no_L82" }
              ],
              "size_170": [
                { label: "<b class='wg-custom-notranslate'>60-65 kg <span>(132-143 lb)</span></b>", resultId: "no_S82" },
                { label: "<b class='wg-custom-notranslate'>65-70 kg <span>(143-154 lb)</span></b>", resultId: "no_M84" },
                { label: "<b class='wg-custom-notranslate'>70-75 kg <span>(154-165 lb)</span></b>", resultId: "no_L86" },
                { label: "<b class='wg-custom-notranslate'>75-80 kg <span>(165-176 lb)</span></b>", resultId: "no_LL86" }
              ],
              "size_175": [
                { label: "<b class='wg-custom-notranslate'>60-65 kg <span>(132-143 lb)</span></b>", resultId: "no_M84" },
                { label: "<b class='wg-custom-notranslate'>65-70 kg <span>(143-154 lb)</span></b>", resultId: "no_M84" },
                { label: "<b class='wg-custom-notranslate'>70-75 kg <span>(154-165 lb)</span></b>", resultId: "no_L86" },
                { label: "<b class='wg-custom-notranslate'>75-80 kg <span>(165-176 lb)</span></b>", resultId: "no_LL86" },
                { label: "<b class='wg-custom-notranslate'>80-85 kg <span>(176-187 lb)</span></b>", resultId: "no_LL86" }
              ],
              "size_180": [
                { label: "<b class='wg-custom-notranslate'>65-70 kg <span>(143-154 lb)</span></b>", resultId: "no_L86" },
                { label: "<b class='wg-custom-notranslate'>70-75 kg <span>(154-165 lb)</span></b>", resultId: "no_LL86" },
                { label: "<b class='wg-custom-notranslate'>75-80 kg <span>(165-176 lb)</span></b>", resultId: "no_LL86" },
                { label: "<b class='wg-custom-notranslate'>80-85 kg <span>(176-187 lb)</span></b>", resultId: "no_3L87" },
              ]
            }
          },
          results: {
            "yes_S78": "S78",
            "yes_S82": "S82",
            "yes_M80": "M80",
            "yes_M84": "M84",
            "yes_M88": "M88",
            "yes_L82": "L82",
            "yes_L86": "L86",
            "yes_L90": "L90",
            "yes_LL82": "LL82",
            "yes_LL86": "LL86",
            "yes_3L87": "3L87",
            "no_S82": "S82",
            "no_M80": "M80",
            "no_L82": "L82",
            "no_L82": "L82",
            "no_S82": "S82",
            "no_M84": "M84",
            "no_L86": "L86",
            "no_LL86": "LL86",
            "no_M84": "M84",
            "no_M84": "M84",
            "no_L86": "L86",
            "no_LL86": "LL86",
            "no_LL86": "LL86",
            "no_L86": "L86",
            "no_LL86": "LL86",
            "no_LL86": "LL86",
            "no_3L87": "3L87"
          }
        };
      }
      const menJacketModal = (handle) => {
        const tableData = [
          { jp: "SS", type: "Standard/<br>Average", int: "XXS", us: "32", eu: "42", chest: "86 - 90 cm<br>(33.9 - 35.5 inch)" },
          { jp: "S",  type: "Standard/<br>Average", int: "XS",  us: "34", eu: "44", chest: "88 - 92 cm<br>(34.7 - 36.3 inch)" },
          { jp: "M",  type: "Standard/<br>Average", int: "S",   us: "36", eu: "46", chest: "90 - 94 cm<br>(35.5 - 37.1 inch)" },
          { jp: "L",  type: "Standard/<br>Average", int: "M",   us: "38", eu: "48", chest: "92 - 96 cm<br>(36.3 - 37.8 inch)" },
          { jp: "LL", type: "Standard/<br>Average", int: "L",   us: "40", eu: "50", chest: "94 - 98 cm<br>(37.1 - 38.6 inch)" },
          { jp: "3L", type: "Standard/<br>Average", int: "XL",  us: "42", eu: "52", chest: "96 - 100 cm<br>(37.8 - 39.4 inch)" },
          { jp: "ABS",  type: "Athletic", int: "Broader chest & waist than 'S'",   us: "Broader chest & waist than 'S'",   eu: "Broader chest & waist than 'S'",   chest: "98 - 102 cm<br>(38.6 - 40.2 inch)" },
          { jp: "ABM",  type: "Athletic", int: "Broader chest & waist than 'M'", us: "Broader chest & waist than 'M'", eu: "Broader chest & waist than 'M'", chest: "100 - 104 cm<br>(39.4 - 41 inch)" },
          { jp: "ABL",  type: "Athletic", int: "Broader chest & waist than 'L'", us: "Broader chest & waist than 'L'", eu: "Broader chest & waist than 'L'", chest: "102 - 106 cm<br>(40.2 - 41.8 inch)" },
          { jp: "ABLL", type: "Athletic", int: "Broader chest & waist than 'LL'", us: "Broader chest & waist than 'LL'", eu: "Broader chest & waist than 'LL'", chest: "104 - 108 cm<br>(41 - 42.6 inch)" },
          { jp: "AB3L", type: "Athletic", int: "Broader chest & waist than '3L'", us: "Broader chest & waist than '3L'", eu: "Broader chest & waist than '3L'", chest: "106 - 112 cm<br>(41.8 - 44.1 inch)" }
        ];


        // テーブルのHTMLを生成する内部関数
        const generateGridHTML = (unit = 'us') => {
          // flowDataMapから直接取得するように修正
          const currentData = this.flowDataMap[handle];
          const availableSizes = currentData?.availableSizes || new Set();

          const rows = tableData.map(row => {
            const sizeKey = row.jp.trim();
            const num = parseFloat(sizeKey);

            // 【重要】シューズと同じ判定ロジックを入れる
            let isAvailable = availableSizes.has(sizeKey) || (!isNaN(num) && (availableSizes.has(num.toString()) || availableSizes.has(num.toFixed(1))));

            let displaySize = row[unit];

            // 在庫判定:
            // resultsには "fixed_size" しか入っていないため、
            // ここでは row.jp (サイズ名) を直接使って判定ロジックを噛ませます
            const sizeWithSpace = sizeKey.replace(/([A-Z]+)(\d+)/g, '$1 $2');

            const href = `/collections/${handle}?filter.v.option.size=${row['jp']}&filter.v.availability=1`;

            // 在庫なしの場合はクラスを付与し、hrefを無効化
            if (!isAvailable) {
              return `
                <a href="javascript:void(0);" class="sizeguide_grid_row fifth out-stock">
                  <div class="sizeguide_grid_item  wg-custom-notranslate">${row.jp}</div>
                  <div class="sizeguide_grid_item dynamic-unit-cell">${displaySize}</div>
                  <div class="sizeguide_grid_item">${row.type}</div>
                  <div class="sizeguide_grid_item wg-custom-notranslate">${row.chest}</div>
                  <div class="sizeguide_grid_item seesize"></div>
                </a>`;
            }

            return `
              <a href="${href}" class="sizeguide_grid_row fifth">
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.jp}</div>
                <div class="sizeguide_grid_item dynamic-unit-cell">${displaySize}</div>
                <div class="sizeguide_grid_item">${row.type}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.chest}</div>
                <div class="sizeguide_grid_item seesize"></div>
              </a>`;
          }).join('');

          const label = unit === 'us' ? 'US' : unit === 'eu' ? 'EU' : unit === 'int' ? 'International Standard' : 'JP';

          return `
            <div class="sizeguide_grid">
              <div class="sizeguide_grid_row sizeguide_grid_header fifth">
                <div class="sizeguide_grid_item">JP</div>
                <div class="sizeguide_grid_item is-clickable" data-jacket-unit-trigger style="position: relative;">
                  <span>${label}</span>
                  <div class="jacket_unit_selector" style="display:none; position: absolute; top: 100%; left: 0; z-index: 10; background: #fff; border: 1px solid #ccc; width: 200px; text-align: left; box-shadow: 0 4px 10px rgba(0,0,0,0.1);">
                    <div data-unit="us" style="padding: 10px; border-bottom: 1px solid #eee;">US</div>
                    <div data-unit="eu" style="padding: 10px; border-bottom: 1px solid #eee;">EU</div>
                    <div data-unit="int" style="padding: 10px;">International Standard</div>
                  </div>
                </div>
                <div class="sizeguide_grid_item">Body Type</div>
                <div class="sizeguide_grid_item">Body Chest<br>(Approx.)</div>
                <div class="sizeguide_grid_item sizeguide_grid_icn">
                  <div><img src="https://cdn.shopify.com/s/files/1/0790/7501/7011/files/sizeguide_shopsize_icn.svg" alt="Shop your size" width="43" height="58" loading="lazy"></div>
                </div>
              </div>
              ${rows}
            </div>
          `;
        };

        return {
          title: "Men's Jacket",
          handle: handle,
          isGridModal: true, // テーブル用フラグ
          generateGrid: generateGridHTML,
          results: {
            "fixed_size": "jacket_table" // 初期値
          }
        };
      }
      const menPantsModal = (handle) => {
        // 画像に基づいたデータセット
        const dressPantsData = [
          { jp: "73", int: "29" }, { jp: "76", int: "30" }, { jp: "79", int: "32" },
          { jp: "82", int: "33" }, { jp: "85", int: "34" }, { jp: "88", int: "35" },
          { jp: "91", int: "36" }, { jp: "94", int: "38" }, { jp: "97", int: "39" },
          { jp: "100", int: "40" }
        ];

        const otherPantsData = [
          { jp: "SS", int: "28" }, { jp: "S", int: "30" }, { jp: "M", int: "31" },
          { jp: "L", int: "33" }, { jp: "LL", int: "34" }, { jp: "3L", int: "36" }
        ];

        const generateGridHTML = () => {
          // flowDataMapから直接取得するように修正
          const currentData = this.flowDataMap[handle];
          const availableSizes = currentData?.availableSizes || new Set();

          const createRows = (data) => data.map(row => {
            // 在庫判定
            const sizeKey = row.jp.trim();
            const num = parseFloat(sizeKey);

            let isAvailable = availableSizes.has(sizeKey) ||
                          (!isNaN(num) && (availableSizes.has(num.toString()) || availableSizes.has(num.toFixed(1))));

            // リンク先URLの生成
            const href = `/collections/${handle}?filter.v.option.size=${row.jp}&filter.v.availability=1`;

            // 在庫がない場合
            if (!isAvailable) {
              return `
              <a href="javascript:void(0);" class="sizeguide_grid_row third out-stock">
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.jp}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.int}</div>
                <div class="sizeguide_grid_item seesize"></div>
              </a>`;
            }
            return `
            <a href="${href}" class="sizeguide_grid_row third">
              <div class="sizeguide_grid_item wg-custom-notranslate">${row.jp}</div>
              <div class="sizeguide_grid_item wg-custom-notranslate">${row.int}</div>
              <div class="sizeguide_grid_item seesize"></div>
            </a>`;
          }).join('');

          return `
            <div class="sizeguide_grid_container pants-grid">
              <p class="sizeguide_grid_title">Dress Pants</p>
              <div class="sizeguide_grid">
                <div class="sizeguide_grid_row sizeguide_grid_header third">
                  <div class="sizeguide_grid_item">JP</div>
                  <div class="sizeguide_grid_item">US/International Standard</div>
                  <div class="sizeguide_grid_item sizeguide_grid_icn">
                    <div><img src="https://cdn.shopify.com/s/files/1/0790/7501/7011/files/sizeguide_shopsize_icn.svg" alt="Shop your size" width="43" height="58" loading="lazy"></div>
                  </div>
                </div>
                ${createRows(dressPantsData)}
              </div>

              <p class="sizeguide_grid_title">Other Pants</p>
              <div class="sizeguide_grid">
                <div class="sizeguide_grid_row sizeguide_grid_header third">
                  <div class="sizeguide_grid_item">JP</div>
                  <div class="sizeguide_grid_item">US/International Standard</div>
                  <div class="sizeguide_grid_item sizeguide_grid_icn">
                    <div><img src="https://cdn.shopify.com/s/files/1/0790/7501/7011/files/sizeguide_shopsize_icn.svg" alt="Shop your size" width="43" height="58" loading="lazy"></div>
                  </div>
                </div>
                ${createRows(otherPantsData)}
              </div>
            </div>
          `;
        };
        return {
          title: "Men's Pants",
          handle: handle,
          isGridModal: true, // resultOnlyFlgで判定されるフラグ
          generateGrid: generateGridHTML,
          results: {
            "fixed_size": "pants_grid"
          }
        };
      }
      const menTopsModal = (handle) => {
        const topsData = [
          { jp: "S",  int: "XS",  us: "34", eu: "44" },
          { jp: "M",  int: "S",   us: "36", eu: "46" },
          { jp: "L",  int: "M",   us: "38", eu: "48" },
          { jp: "LL", int: "L",   us: "40", eu: "50" },
          { jp: "3L", int: "XL",  us: "42", eu: "52" },
          { jp: "4L", int: "XXL", us: "44", eu: "54" }
        ];

        const generateGridHTML = () => {
          // flowDataMapから直接取得するように修正
          const currentData = this.flowDataMap[handle];
          const availableSizes = currentData?.availableSizes || new Set();

          const rows = topsData.map(row => {
            const sizeKey = row.jp.trim();
            const num = parseFloat(sizeKey);

            // 【重要】シューズと同じ判定ロジックを入れる
            let isAvailable = availableSizes.has(sizeKey) || (!isNaN(num) && (availableSizes.has(num.toString()) || availableSizes.has(num.toFixed(1))));

            const href = `/collections/${handle}?filter.v.option.size=${row.jp}&filter.v.availability=1`;

            // 在庫がない場合
            if (!isAvailable) {
              return `
              <a href="javascript:void(0);" class="sizeguide_grid_row fifth out-stock">
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.jp}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.int}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.us}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.eu}</div>
                <div class="sizeguide_grid_item seesize"></div>
              </a>`;
            }
              return `
              <a href="${href}" class="sizeguide_grid_row fifth">
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.jp}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.int}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.us}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.eu}</div>
                <div class="sizeguide_grid_item seesize"></div>
              </a>`;
          }).join('');

          return `
            <div class="sizeguide_grid_container tops-grid ">
              <div class="sizeguide_grid">
                <div class="sizeguide_grid_row sizeguide_grid_header fifth">
                  <div class="sizeguide_grid_item">JP</div>
                  <div class="sizeguide_grid_item">International<br>Standard</div>
                  <div class="sizeguide_grid_item">US</div>
                  <div class="sizeguide_grid_item">EU</div>
                  <div class="sizeguide_grid_item sizeguide_grid_icn">
                    <div><img src="https://cdn.shopify.com/s/files/1/0790/7501/7011/files/sizeguide_shopsize_icn.svg" alt="Shop your size" width="43" height="58" loading="lazy"></div>
                  </div>
                </div>
                ${rows}
              </div>
            </div>
          `;
        };

        return {
          title: "Men's Tops",
          handle: handle,
          isGridModal: true,
          generateGrid: generateGridHTML,
          results: {
            "fixed_size": "tops_grid"
          }
        };
      };
      const menShoesModal = (handle) => {
        const topsData = [
          { jp: "24.5", int: "6", us: "6.5", eu: "39.5"},
          { jp: "25", int: "6.5", us: "7", eu: "40"},
          { jp: "25.5", int: "7", us: "7.5", eu: "40.5"},
          { jp: "26", int: "7.5", us: "8", eu: "41"},
          { jp: "26.5", int: "8", us: "8.5", eu: "41.5"},
          { jp: "27", int: "8.5", us: "9", eu: "42"},
          { jp: "27.5", int: "9", us: "9.5", eu: "42.5"}
        ];

        const generateGridHTML = () => {
          // flowDataMapから直接取得するように修正
          const currentData = this.flowDataMap[handle];
          const availableSizes = currentData?.availableSizes || new Set();

          const rows = topsData.map(row => {
            const sizeKey = row.jp.trim();
            const num = parseFloat(sizeKey);

            // 【重要】シューズと同じ判定ロジックを入れる
            let isAvailable = availableSizes.has(sizeKey) || (!isNaN(num) && (availableSizes.has(num.toString()) || availableSizes.has(num.toFixed(1))));


            const href = `/collections/${handle}?filter.v.option.size=${row.jp}&filter.v.availability=1`;

            // 在庫がない場合
            if (!isAvailable) {
              return `
                <a href="javascript:void(0);" class="sizeguide_grid_row fifth out-stock">
                  <div class="sizeguide_grid_item wg-custom-notranslate">${row.jp}</div>
                  <div class="sizeguide_grid_item wg-custom-notranslate">${row.int}</div>
                  <div class="sizeguide_grid_item wg-custom-notranslate">${row.us}</div>
                  <div class="sizeguide_grid_item wg-custom-notranslate">${row.eu}</div>
                  <div class="sizeguide_grid_item seesize"></div>
                </a>`;
            }

            // 在庫がある場合（通常通り）
            return `
              <a href="${href}" class="sizeguide_grid_row fifth">
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.jp}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.int}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.us}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.eu}</div>
                <div class="sizeguide_grid_item seesize"></div>
              </a>`;
          }).join('');

          return `
            <div class="sizeguide_grid_container tops-grid ">
              <div class="sizeguide_grid">
                <div class="sizeguide_grid_row sizeguide_grid_header fifth">
                  <div class="sizeguide_grid_item">JP</div>
                  <div class="sizeguide_grid_item">UK</div>
                  <div class="sizeguide_grid_item">US</div>
                  <div class="sizeguide_grid_item">EU</div>
                  <div class="sizeguide_grid_item sizeguide_grid_icn">
                    <div><img src="https://cdn.shopify.com/s/files/1/0790/7501/7011/files/sizeguide_shopsize_icn.svg" alt="Shop your size" width="43" height="58" loading="lazy"></div>
                  </div>
                </div>
                ${rows}
              </div>
            </div>
          `;
        };

        return {
          title: "Men's Shoes",
          handle: handle,
          isGridModal: true,
          generateGrid: generateGridHTML,
          results: {
            "fixed_size": "tops_grid"
          }
        };
      };
      const womenJacketTopsModal = (handle) => {
        const topsData = [
          { jp: "SS (5)", int: "XXS", us: "0-2", eu: "32"},
          { jp: "S (7)", int: "XS", us: "4", eu: "34"},
          { jp: "M (9)", int: "S", us: "6", eu: "36"},
          { jp: "L (11)", int: "M", us: "8", eu: "38"},
          { jp: "LL (13)", int: "L", us: "10", eu: "40"},
          { jp: "3L (15)", int: "XL", us: "12", eu: "42"},
          { jp: "4L", int: "XXL", us: "14", eu: "44"},
          { jp: "F", int: "Free", us: "Free", eu: "Free"}
        ];

        const generateGridHTML = () => {
          // flowDataMapから直接取得するように修正
          const currentData = this.flowDataMap[handle];
          const availableSizes = currentData?.availableSizes || new Set();

          const rows = topsData.map(row => {
            const rawSize = row.jp.trim();
            const sizeKey = rawSize.replace(/\s\(\d+\)/g, ''); // "SS (5)" -> "SS" に変換してから判定
            const isAvailable = availableSizes.has(sizeKey);

            const num = parseFloat(sizeKey);

            const filteredSize = row.jp.replace(/\s\(\d+\)/g, '');
            const href = `/collections/${handle}?filter.v.option.size=${filteredSize}&filter.v.availability=1`;

            if (!isAvailable) {
              return `
                <a href="javascript:void(0);" class="sizeguide_grid_row fifth out-stock">
                  <div class="sizeguide_grid_item wg-custom-notranslate">${row.jp}</div>
                  <div class="sizeguide_grid_item wg-custom-notranslate">${row.int}</div>
                  <div class="sizeguide_grid_item wg-custom-notranslate">${row.us}</div>
                  <div class="sizeguide_grid_item wg-custom-notranslate">${row.eu}</div>
                  <div class="sizeguide_grid_item seesize"></div>
                </a>`;
            }
            return `
              <a href="${href}" class="sizeguide_grid_row fifth">
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.jp}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.int}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.us}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.eu}</div>
                <div class="sizeguide_grid_item seesize"></div>
              </a>`;
          }).join('');

          return `
            <div class="sizeguide_grid_container tops-grid ">
              <div class="sizeguide_grid">
                <div class="sizeguide_grid_row sizeguide_grid_header fifth">
                  <div class="sizeguide_grid_item">JP</div>
                  <div class="sizeguide_grid_item">International<br>Standard</div>
                  <div class="sizeguide_grid_item">US</div>
                  <div class="sizeguide_grid_item">EU</div>
                  <div class="sizeguide_grid_item sizeguide_grid_icn">
                    <div><img src="https://cdn.shopify.com/s/files/1/0790/7501/7011/files/sizeguide_shopsize_icn.svg" alt="Shop your size" width="43" height="58" loading="lazy"></div>
                  </div>
                </div>
                ${rows}
              </div>
            </div>
          `;
        };

        return {
          title: "Womens Jacket/Tops",
          handle: handle,
          isGridModal: true,
          generateGrid: generateGridHTML,
          results: {
            "fixed_size": "tops_grid"
          }
        };
      };
      const womenBottomsModal = (handle) => {
        const topsData = [
          { jp: "SS (5)", int: "XXS", us: "0-2"},
          { jp: "S (7)", int: "XS", us: "4"},
          { jp: "M (9)", int: "S", us: "6"},
          { jp: "L (11)", int: "M", us: "8"},
          { jp: "LL (13)", int: "L", us: "10"},
          { jp: "3L (15)", int: "XL", us: "12"},
          { jp: "4L (17)", int: "XXL", us: "14" }
        ];

        const generateGridHTML = () => {
          // flowDataMapから直接取得するように修正
          const currentData = this.flowDataMap[handle];
          const availableSizes = currentData?.availableSizes || new Set();

          const rows = topsData.map(row => {
            // --- 修正ロジック ---
            const rawLabel = row.jp.trim(); // "SS (5)"

            // 1. アルファベット部分のみ抽出 (例: "SS")
            const sizeAlpha = rawLabel.replace(/\s\(\d+\)/g, '');
            // 2. 括弧内の数値部分のみ抽出 (例: "5")
            const sizeNumMatch = rawLabel.match(/\((\d+)\)/);
            const sizeNum = sizeNumMatch ? sizeNumMatch[1] : null;

            // 判定：アルファベット形式(SS) か 数値形式(5) のどちらかが在庫リストにあればOK
            let isAvailable = availableSizes.has(rawLabel) || availableSizes.has(sizeAlpha) || (sizeNum && availableSizes.has(sizeNum));

            const filteredSize = sizeAlpha; // リンク用URLはアルファベットを使用
            const href = `/collections/${handle}?filter.v.option.size=${filteredSize}&filter.v.availability=1`;

            // 在庫がない場合
            if (!isAvailable) {
              return `
                <a href="javascript:void(0);" class="sizeguide_grid_row forth out-stock">
                  <div class="sizeguide_grid_item wg-custom-notranslate">${row.jp}</div>
                  <div class="sizeguide_grid_item wg-custom-notranslate">${row.int}</div>
                  <div class="sizeguide_grid_item wg-custom-notranslate">${row.us}</div>
                  <div class="sizeguide_grid_item seesize"></div>
                </a>`;
            }
            return `
              <a href="${href}" class="sizeguide_grid_row forth">
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.jp}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.int}</div>
                <div class="sizeguide_grid_item wg-custom-notranslate">${row.us}</div>
                <div class="sizeguide_grid_item seesize"></div>
              </a>`;
          }).join('');

          return `
            <div class="sizeguide_grid_container tops-grid ">
              <div class="sizeguide_grid">
                <div class="sizeguide_grid_row sizeguide_grid_header forth">
                  <div class="sizeguide_grid_item">JP</div>
                  <div class="sizeguide_grid_item">International<br>Standard</div>
                  <div class="sizeguide_grid_item">US</div>
                  <div class="sizeguide_grid_item sizeguide_grid_icn">
                    <div><img src="https://cdn.shopify.com/s/files/1/0790/7501/7011/files/sizeguide_shopsize_icn.svg" alt="Shop your size" width="43" height="58" loading="lazy"></div>
                  </div>
                </div>
                ${rows}
              </div>
            </div>
          `;
        };

        return {
          title: "Womens Bottoms",
          handle: handle,
          isGridModal: true,
          generateGrid: generateGridHTML,
          results: {
            "fixed_size": "tops_grid"
          }
        };
      };

      switch (handle) {
        case 'mens-business-suits-orihica': return menBusinessSuitsModal(handle);
        case 'mens-long-sleeve-business-shirts-orihica': return menBusinessShirtModal(handle);
        case 'orihica-men-jacket': return menJacketModal(handle);
        case 'orihica-men-pants': return menPantsModal(handle);
        case 'orihica-men-tops': return menTopsModal(handle);
        case 'mens-business-shoes-orihica': return menShoesModal(handle);
        case 'womens-jacket-and-tops-orihica': return womenJacketTopsModal(handle);
        case 'womens-bottoms-orihica': return womenBottomsModal(handle);
        default: return null;
      }
    }
  }

  // クラスのインスタンス化
  new SizeGuideApp();
});